export default __webpack_public_path__ + "static/media/pt-flag.a8e9124e.svg";